import React, { useEffect, useState } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevelMultiplier } from './style';
import { calculateTimeLeftLabel } from 'templates/PlayerLevel/utils';

export const HeartOfVegasLeaguesPlayerLevel: React.FC<IPlayerLevel> = ({
  assetUrl,
  text = [],
  endsIn,
  onTimerDoneHandler,
}) => {
  const [timeLeftLabel, setTimeLeftLabel] = useState(
    endsIn ? calculateTimeLeftLabel({ endsIn, onTimerDoneHandler }) : '',
  );

  useEffect(() => {
    if (!endsIn) {
      return;
    }
    const timer = setInterval(() => {
      setTimeLeftLabel(calculateTimeLeftLabel({ endsIn, onTimerDoneHandler }));
    }, 1000);

    return () => clearInterval(timer);
  }, [endsIn]);

  return (
    <StyledPlayerLevelMultiplier className={'player-level multiplier'}>
      <img className={'image'} src={assetUrl} alt={'value player level'} />
      <div className="text-container">
        {Array.isArray(text) &&
          text.map((item) => (
            <div key={item.id} className={`text-${item.id}`}>
              {item.content}
            </div>
          ))}
      </div>
      {endsIn && (
        <div className="timer">
          <div className="text">Ends in</div>
          <div className="value">{timeLeftLabel}</div>
        </div>
      )}
    </StyledPlayerLevelMultiplier>
  );
};
